module.exports = __webpack_public_path__ + "static/img/hbys.cfc5c1af.png";